import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import "./i18n"; // Import i18n before rendering
import { CssBaseline } from "@mui/material";
import { AppStateProvider } from "./hook/app-state";
import { EnhancedAuthenticationProvider } from "./hook/auth-context";
import { ScoresStateProvider } from "./hook/scores-state";
import { AppointmentProvider } from "./hook/appointment-state";
import { UserDetailsProvider } from "./hook/user-details";
import InitialLoader from "./components/loaders/IntialLoader";
import { PollingStateProvider } from "./hook/polling-states";
import { CartProvider } from "./hook/cart-state";
import { PanchkarmaProvider } from "./hook/panchkarma-state";
import "./fonts.css";
import { DashboardProvider } from "./hook/dashbaord-state";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <React.StrictMode>
  <>
    <CssBaseline />
    <AppStateProvider>
      <EnhancedAuthenticationProvider>
        <CartProvider>
          <DashboardProvider>
            <PanchkarmaProvider>
              <UserDetailsProvider>
                <ScoresStateProvider>
                  <PollingStateProvider>
                    <AppointmentProvider>
                      <Suspense fallback={<InitialLoader />}>
                        <App />
                      </Suspense>
                    </AppointmentProvider>
                  </PollingStateProvider>
                </ScoresStateProvider>
              </UserDetailsProvider>
            </PanchkarmaProvider>
          </DashboardProvider>
        </CartProvider>
      </EnhancedAuthenticationProvider>
    </AppStateProvider>
    </>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
